import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Text } from 'rebass/styled-components'

import styles from './BreadcrumbTitle.module.css'

export interface TitleItem {
  type: 'title'
  text?: string | React.ReactNode
  textId?: string
  as?: React.ElementType
}

export const BreadcrumbTitle = ({ as = 'h1', text, textId }: TitleItem): JSX.Element => (
  <Text data-name="BreadcrumbTitle" className={styles.breadcrumbTitle} as={as} variant="heading.md">
    {textId ? <FormattedMessage id={textId} /> : text}
  </Text>
)
